import { IExportColumnModel } from "../../../../../../shared/models";

export const AppletsColumnList: IExportColumnModel[] = [
]